import {
    createObjectField,
    createPrimitiveField,
    createUnionField,
    type InferFieldValue,
    literal,
    nullable,
    type ValidationError,
} from '@adv-frontend/form-kit';
import { OrderDeliveryServices, type ServiceType } from '../../../api/order';

export const intervalField = createUnionField({
    key: 'type',
    defaultValue: { type: 'notInterval' },
    fields: [
        createObjectField({
            validators: (createValidators) => createValidators<ValidationError<'REQUIRED_DELIVERY_INTERVAL'>>({}),
            fields: {
                type: createPrimitiveField({ defaultValue: literal<'notInterval'>('notInterval') }),
            },
        }),
        createObjectField({
            validators: (createValidators) => createValidators<ValidationError<'REQUIRED_DELIVERY_INTERVAL'>>({}),
            fields: {
                type: createPrimitiveField({ defaultValue: literal<'interval'>('interval') }),
                from: createPrimitiveField({ defaultValue: Date.now() }),
                to: createPrimitiveField({ defaultValue: Date.now() }),
                serviceType: createPrimitiveField({
                    defaultValue: literal<ServiceType>(OrderDeliveryServices.YANDEX_DELIVERY),
                }),
                price: createPrimitiveField({ defaultValue: nullable<string>(null) }),
                currency: createPrimitiveField({ defaultValue: nullable<string>(null) }),
            },
        }),
    ],
});

export type IntervalFieldValue = InferFieldValue<typeof intervalField>;
